var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 135.771,
    height: 23.277,
    viewBox: "0 0 135.771 23.277",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-225 -988)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(288.345 988)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M277.61,19.9h-8.5a1.858,1.858,0,0,0,1.206,1.738,8.739,8.739,0,0,0,2.75.522,25.539,25.539,0,0,0,3.365-.414l.491,2.648a14.44,14.44,0,0,1-5.717.677,8.821,8.821,0,0,1-1.621-.294,5.749,5.749,0,0,1-4.4-6.313,6.081,6.081,0,0,1,5.176-5.913,7.528,7.528,0,0,1,3.847.323c2.416.875,3.729,3.231,3.491,6.2C277.686,19.321,277.65,19.561,277.61,19.9Zm-3.615-2.361a2.205,2.205,0,0,0-2.377-2.291,2.246,2.246,0,0,0-2.426,2.291Z",
    transform: "translate(-219.724 -6.284)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.441,19.2l.883,2.88c-.583.245-1.133.514-1.707.712a10,10,0,0,1-5.159.34,6.037,6.037,0,0,1-4.722-3.733,11.917,11.917,0,0,1-.129-9.277,7.231,7.231,0,0,1,8.7-4.366,15.745,15.745,0,0,1,2.406.883.577.577,0,0,1,.275.483c-.259.927-.567,1.841-.819,2.634A21.131,21.131,0,0,0,205.992,9c-2.429-.2-3.868.917-4.458,3.286a8.957,8.957,0,0,0,.075,4.582,3.752,3.752,0,0,0,4.221,3.009A32.572,32.572,0,0,0,209.441,19.2Z",
    transform: "translate(-197.731 -4.029)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.184,18.566a46.516,46.516,0,0,1,5.035,6.517c-1.445,0-2.76.017-4.072-.02-.177,0-.386-.247-.514-.427-.7-.991-1.369-2-2.063-2.995-.186-.266-.421-.5-.731-.857-.9,1.3-1.774,2.512-2.588,3.763a1.009,1.009,0,0,1-1,.549c-1.1-.037-2.2-.012-3.466-.012a47.178,47.178,0,0,1,4.934-6.471l-4.824-6.087c1.487,0,2.825-.014,4.162.018.166,0,.361.22.484.383.834,1.11,1.652,2.233,2.521,3.413.83-1.124,1.65-2.187,2.413-3.29a1.123,1.123,0,0,1,1.094-.539c1.094.037,2.191.011,3.469.011Z",
    transform: "translate(-225.794 -6.307)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.411,29.245l.5-2.725c.379.086.711.185,1.05.232,1.469.2,2-.444,2.447-1.751.063-.183-.087-.457-.178-.673a75.559,75.559,0,0,1-3.574-10.641c-.048-.188-.073-.382-.117-.616h3.068l2.174,7.89.17.019c.084-.247.184-.489.247-.741.536-2.113,1.1-4.222,1.579-6.347.146-.643.342-.95,1.06-.871a20.053,20.053,0,0,0,2.155.017,2.955,2.955,0,0,1-.037.483,97.9,97.9,0,0,1-4.094,12.7c-.142.346-.31.681-.469,1.021C235.179,29.829,232.908,30.246,230.411,29.245Z",
    transform: "translate(-208.388 -6.469)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.3,3.3v.768q0,6.32,0,12.639c0,.111,0,.221,0,.331.028,1.472.348,1.853,1.877,2.142-.071.463-.137.932-.214,1.4s-.165.947-.257,1.472a5.613,5.613,0,0,1-3.659-.913,3.082,3.082,0,0,1-1.175-2.416c-.055-.769-.06-1.543-.061-2.314q-.008-5.889,0-11.78v-.74Z",
    transform: "translate(-216.995 -3.304)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.021,19.231c-.156.95-.307,1.861-.466,2.83a5.786,5.786,0,0,1-3.608-.867,2.783,2.783,0,0,1-1.144-1.873,10.255,10.255,0,0,1-.149-1.711c-.012-4.35-.007-8.7-.007-13.05V3.9l3.469-.584v.844q0,6.094,0,12.189c0,.154,0,.309,0,.464C251.132,18.485,251.359,18.784,253.021,19.231Z",
    transform: "translate(-214.008 -3.307)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.3,25.738h-3.19a4.653,4.653,0,0,1-.048-.467c0-3.552.012-7.1-.007-10.657a.733.733,0,0,1,.606-.834,10.086,10.086,0,0,1,6.75-.2c-.17.923-.343,1.861-.5,2.723l-3.609-.233Z",
    transform: "translate(-204.358 -6.495)",
    fill: "#222f3e"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.741,8.7H139.329l5.128-6.731h32.413Z",
    transform: "translate(98.729 985.53)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.616,21.451H119.2l5.128-6.731h32.413Z",
    transform: "translate(105.796 981.053)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.491,34.2H126.079l5.128-6.731h32.413Z",
    transform: "translate(103.382 976.575)",
    fill: "#222f3e"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkLogo);
export default __webpack_public_path__ + "static/media/dark-logo.45c730365023300e49b51c91572705c0.svg";
export { ForwardRef as ReactComponent };